import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useIntl, FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import FlexColumn from '../../shared/components/layouts/FlexColumn'
import FormikTextField from '../../shared/components/formik/FormikTextField'
import { useAuthentication } from '../../contexts/AuthenticationContext'

const LoginOtpForm = ({ loginToken, message, onResult }) => {
  const intl = useIntl()
  const { verifyOtp } = useAuthentication()

  const validationSchema = Yup.object({
    otpCode: Yup.string()
      .matches(/^\d{6}$/, intl.formatMessage({ id: 'login.otp.error.format' }))
      .required(intl.formatMessage({ id: 'login.error.required' })),
  })

  const formik = useFormik({
    initialValues: {
      otpCode: '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      setStatus(null)
      verifyOtp(loginToken, values.otpCode)
        .then((result) => {
          onResult(result)
        })
        .catch(() => {
          setStatus(intl.formatMessage({ id: 'login.otp.error.invalid' }))
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
  })

  return (
    <FlexColumn gap={2}>
      <Typography variant="body1">
        {message || <FormattedMessage id="login.otp.message" />}
      </Typography>

      {formik.status && (
        <Alert severity="error">{formik.status}</Alert>
      )}

      <Box component="form" onSubmit={formik.handleSubmit} sx={{ width: '100%' }}>
        <FlexColumn gap={2}>
          <FormikTextField
            formik={formik}
            name="otpCode"
            label={<FormattedMessage id="login.otp.label" />}
            autoFocus
            autoComplete="one-time-code"
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={formik.isSubmitting}
          >
            <FormattedMessage id="login.otp.submit" />
          </Button>
        </FlexColumn>
      </Box>
    </FlexColumn>
  )
}

export default LoginOtpForm
